import axios from "axios";
import envConfig from "../../src/config/envConfig";

export const HTTP = axios.create({
  baseURL: envConfig.appBackendUrl,
  // baseURL: `https://1875pb.blueplanet.com.mm/api/`,
  // baseURL: `http://localhost:4500/api/`,
  headers: {
    Authorization: "",
  },
});

export const Horo = axios.create({
  baseURL: envConfig.horoUrl,
  //baseURL: `https://chatbothoro.blueplanet.com.mm/api/v1/`,
  auth: {
    username: "admin2021@horo.com",
    password: "@dM1nU$3r@horo",
  },
});

export const ONEYEAR = axios.create({
  baseURL: envConfig.oneYearBaydinUrl,
  // baseURL: `https://baydin.boom.com.mm/api/`,
  // baseURL: `http://127.0.0.1:8000/api/`
});

export const Address = axios.create({
  baseURL: envConfig.horoUrl.replace("/v1", ""),
  // baseURL: `https://chatbothoro.blueplanet.com.mm/api`,
});
